export default __webpack_public_path__ + "static/bwtransport-8-407cbb39e03e212bb4edbfd55b4e9862.png";